// import {bannerCursorEffect} from "./extensions/cursorEffect";
import {individualBannerSwiper} from "./extensions/individualBannerSwiper";
import {initOilfinderBannerSwiper} from "./extensions/oilfinderBannerSwiper";
import { initOelfinder } from "./extensions/oelfinder";
import { initOilfinderRedirect } from "./extensions/oilfinderRedirect";
import { initHistoryPin } from "./extensions/history";
import { initBlogSlider } from "./extensions/blog";
import { initBlogItemlistSlider } from "./extensions/blogItemListSlider";
import {initItemlistSlider, initItemlistCrosssellerSlider, initItemlistBlogSlider} from "./extensions/itemListSlider";
import {Tooltip} from "./extensions/tooltip";
import {initCrosssellerTabs} from "./extensions/crosssellerTabs";
import {focusInputGroups} from "./extensions/checkInputGroups";
import {initResellerModalHeadlines, initCompatibilityListTruncation} from "./extensions/itemcardFunctions";
import {initVariantSorting} from "./extensions/variantSorting";
import {initSlideContentOnJumpmark} from "./extensions/slidecontentOnJumpmark";
import {initCrosssellerFromExcel} from "./extensions/crossseller";
import {initSearchOverlay} from "./extensions/searchOverlay";
import { createDynamicSkew } from "./extensions/skewCalculator";
import { initTabSlider } from "./extensions/tabSlider";
import { initTabbedTextElement } from "./extensions/tabbedTextElement";
import { initLanguageSwitchHreflang } from "./extensions/languageSwitch";
import { initNumberFacts } from "./extensions/numberFacts";
import { initCategoryBoxAlignment } from "./extensions/categoryBoxAlignment";
import { initContentBoxAlignment } from "./extensions/contentBoxAlignment";
import { initOelfinderCollapse } from "./extensions/oelfinderCollapse";
import { initCatalogDownloadWatermark } from "./extensions/catalogDownloadWatermark";
import { initVideoBannerSpacing } from "./extensions/videoBannerSpacing";


function initFilterToggle() {
    document.querySelectorAll('.filterBox__showAllFilters').forEach(btn => {
        const filterBox = btn.closest('.filterBox');

        const activeCount = filterBox.querySelectorAll('.filterReset').length;
        const countEl = btn.querySelector('.filterBox__activeCount');
        if (countEl && activeCount > 0) {
            countEl.textContent = activeCount;
        }

        btn.addEventListener('click', () => {
            const wrapper = filterBox.querySelector('.filterBox__filtersWrapper');
            if (wrapper) {
                wrapper.classList.toggle('is-expanded');
            }
        });
    });
}

window.addEventListener("load", (event) => {
    // bannerCursorEffect(".hoverEffectBanner", "#E53212");
    // bannerCursorEffect(".imageTextElement.bg--purple-gradient", "#98B1D1");
    // bannerCursorEffect(".js-historySlider", "#98B1D1");
    // bannerCursorEffect(".cursorEffect", "#98B1D1");
    individualBannerSwiper();
    initOilfinderBannerSwiper();
    initHistoryPin();
    initBlogSlider();
    initBlogItemlistSlider();
    initOelfinder();
    initOilfinderRedirect();
    initItemlistSlider();
    initItemlistCrosssellerSlider();
    initCrosssellerTabs();
    initItemlistBlogSlider();
    initResellerModalHeadlines();
    initCompatibilityListTruncation();
    initVariantSorting();
    initSlideContentOnJumpmark();
    initCrosssellerFromExcel();
    initSearchOverlay();
    createDynamicSkew();
    initTabSlider();
    initTabbedTextElement();
    initNumberFacts();
    initCategoryBoxAlignment();
    initContentBoxAlignment();
    initOelfinderCollapse();
    initCatalogDownloadWatermark();
    initVideoBannerSpacing();
    initFilterToggle();
    initLanguageSwitchHreflang();

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl);
    });
});